// extracted by mini-css-extract-plugin
export default {"contentContainer":"common_contentContainer__7M371","journalPopupContainer":"common_journalPopupContainer__zgf1k"};